class Ranking {

    constructor() {

        this.RANKING_TOP_BEST_CATEGORY = 1;
        this.RANKING_TOP_CHALLENGE_CATEGORY = 2;
        this.RANKING_TOP_WISE_CATEGORY = 3;
        this.RANKING_TOP_FASTEST_CATEGORY = 4;
        this.RANKING_TOP_ACCURACY_CATEGORY = 5;

    }

}